import React from "react";

import { GridColumn, GridRow } from "src/common/components/Grid";
import { ActivityChart } from "src/views/stats/ActivityChart";
import { StatusChart } from "src/views/stats/StatusChart";

import "./Stats.css";

export const Stats: React.FunctionComponent = () => {
	return (
		<div className="stats">
			<GridRow>
				<GridColumn columnSize={6}>
					<ActivityChart />
				</GridColumn>
				<GridColumn columnSize={6}>
					<StatusChart />
				</GridColumn>
			</GridRow>
		</div>
	);
};
